export default () => ({
  accountList: [],
  account: null,
});
